<div class="flex flex-col">
  <p-confirmdialog />

  <div class="homepage flex justify-center">
    <img class="scale-75" src="./assets/home.png" />
  </div>
</div>
